import NavBar from "@/components/site/NavBar";
import Hero from "@/components/site/Hero";
import VturbPlayer from "@/components/site/VturbPlayer";
import AttorneyBar from "@/components/site/AttorneyBar";
import FearSection from "@/components/site/FearSection";
import FounderStory from "@/components/site/FounderStory";
import GoogleReviews from "@/components/site/GoogleReviews";
import Testimonials from "@/components/site/Testimonials";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

const headline = (
  <>
    Are you a victim of{" "}
    <span className="italic font-medium text-teal">domestic violence?</span>
  </>
);
const subhead = (
  <>
    You don&rsquo;t have to answer that question alone.{" "}
    <span className="text-ink font-medium">Binoye Jos, Esq.</span> and the JOS
    Family Law team handle domestic violence cases in Orange County with{" "}
    <span className="text-ink font-medium">complete discretion</span>,{" "}
    <span className="text-ink font-medium">same-week availability</span>, and{" "}
    <span className="text-ink font-medium">no judgment</span>. If you&rsquo;re
    in a dangerous situation at home, the right legal help — quickly and
    privately — can change everything.
  </>
);
const pullquote = (
  <>
    Help can be private. Help can be fast.{" "}
    <span className="italic text-teal">
      Reaching out doesn&rsquo;t commit you to anything — but it can open every
      door.
    </span>
  </>
);

export default function DomesticViolenceVSLSplit() {
  return (
    <main data-testid="dv-vsl-split-page" className="relative bg-paper text-ink">
      <NavBar />
      <Hero
        headline={headline}
        subhead={subhead}
        pullquote={pullquote}
        pullquoteLabel="Our Promise"
        source="DV VSL v2"
        statBar={null}
        showPriorResultsDisclaimer={false}
        primaryCtaLabel="Get Confidential Help Now"
        ctaSubNote="Private · Confidential · No Obligation"
        formCtaLabel="Get Confidential Help Now"
        compact
      />
      <VturbPlayer videoId="6a59d1312c7c951cdbed9681" />
      <AttorneyBar />
      <FearSection />
      <FounderStory />
      <GoogleReviews />
      <Testimonials />
      <FinalCTA source="DV VSL v2" />
      <Footer />
    </main>
  );
}
